(function () {

jQuery(document).ready(function($) {
    // Focus styles for menus when using keyboard navigation
    // Properly update the ARIA states on focus (keyboard) and mouse over events
    $('[role="menubar"]').on("focus.aria mouseenter.aria", '[aria-haspopup="true"]', function(ev) {
        $(ev.currentTarget).attr("aria-expanded", true);
    });
    // Properly update the ARIA states on blur (keyboard) and mouse out events
    $('[role="menubar"]').on("blur.aria mouseleave.aria", '[aria-haspopup="true"]', function(ev) {
        $(ev.currentTarget).attr("aria-expanded", false);
    });
    // position mega menu
    $("li.mega-menu").hover(function() {}, function() {});
    // inview js
    let initInview = function() {
        $(".on-inview").each(function() {
            let target = $(this);
            target.on("inview", function(event, isInView) {
                if (isInView) $(this).addClass("slide-top");
            });
        });
    };
    // mobile nav
    let initMobileNav = function() {
        $(".mobile-nav-toggle").on("click", function() {
            let toggle = $(this);
            let mobileNav = $("#mobile-nav-wrapper");
            let headerHeight = $("#masthead").height();
            let windowHeight = $(window).height();
            toggle.toggleClass("is-active");
            $(".mobile-navigation").css("top", headerHeight + 100);
            $("#mobile-nav-wrapper").css("height", windowHeight - headerHeight);
            if (toggle.hasClass("is-active")) {
                $("body,html,main").addClass("mobile-nav-is-active");
                $("#mobile-nav-wrapper").addClass("is-active");
            } else {
                $("#mobile-nav-wrapper").removeClass("is-active");
                $("body,html,main").removeClass("mobile-nav-is-active");
            }
        });
        $(".mobile-navigation li.menu-item-has-children > a").on("click", function(event) {
            event.preventDefault();
            event.stopPropagation();
            $(this).parent("li").toggleClass("is-active");
        });
    };
    initMobileNav();
    // add ids to flexible content
    let addIdstoFcls = function() {
        $("main .fcl").each(function(index) {
            $(this).attr("id", "section-" + index);
        });
    };
    addIdstoFcls();
    // init slick slider
    let initSlider = function() {
        $(".slick-slider").slick({
            "arrows": false,
            "dots": true,
            "infinite": true,
            "autoplay": true
        });
    };
    initSlider();
    // init photo gallery carousel
    let initGalleryCarousel = function() {
        $(".photo-gallery-carousel").slick({
            arrows: true,
            dots: true,
            infinite: true,
            autoplay: true,
            autoplaySpeed: 4000,
            speed: 500,
            fade: true,
            cssEase: "ease-in-out",
            pauseOnHover: true
        });
    };
    initGalleryCarousel();
    // menu hover
    let initMenuHover = function() {
        if ($(".main-navigation > li").length > 0) $(".main-navigation > li").hover(function() {
            $(this).addClass("is-hovering");
        }, function() {
            $(this).removeClass("is-hovering");
        });
    };
    initMenuHover();
    // child toggle 
    let initToggles = function() {
        if ($(".single-toggle-child-group").length > 0) {
            $(".single-toggle-group > h4").each(function() {
                let parentToggle = $(this);
                parentToggle.on("click", function() {
                    parentToggle.closest(".single-toggle-group").toggleClass("active");
                });
            });
            $(".single-toggle-child-group > p").on("click", function(e) {
                e.stopPropagation(); // Stop the event from propagating to parent elements
                let childToggle = $(this);
                childToggle.closest(".single-toggle-child-group").toggleClass("active");
            });
        }
    };
    initToggles();
    let filterTeam = function() {
        if ($("#filter-team-form").length > 0) $("#filter-team-form").on("submit", function(event) {
            event.preventDefault();
            let selectVal = $("#filter-team").val();
            console.log(selectVal);
            // Show all nord-single-runner divs
            $(".nord-single-runner").show();
            if (selectVal != "all") // Hide the divs that do not contain the selectVal in their data-events attribute
            $(".nord-single-runner").filter(function() {
                let events = $(this).data("events");
                return events ? !String(events).split(" ").includes(selectVal) : true;
            }).hide();
            else $(".nord-single-runner").show();
            // Check if all nord-single-runner divs are hidden and display a message if true
            if ($(".nord-single-runner:visible").length === 0) {
                $("#no-runner-message").remove(); // Remove existing message if any
                $("#filter-team-form").after('<div id="no-runner-message"><h4>Sorry, no runner found for the selected event.</h4><p>Please update your filter</p></div>');
            } else $("#no-runner-message").remove(); // Remove the message if there are visible runners
        });
    };
    filterTeam();
    let initPopupGallery = function() {
        $(".photo-gallery-carousel").each(function() {
            let gallery = $(this);
            gallery.magnificPopup({
                delegate: "a",
                type: "image",
                tLoading: "Loading image #%curr%...",
                mainClass: "mfp-img-mobile",
                gallery: {
                    enabled: true,
                    navigateByImgClick: true,
                    preload: [
                        0,
                        1
                    ] // Will preload 0 - before current, and 1 after the current image
                },
                image: {
                    tError: '<a href="%url%">The image #%curr%</a> could not be loaded.'
                }
            });
        });
    };
    initPopupGallery();
    var lastScrollTop = 0;
    $(window).scroll(function() {
        var st = $(this).scrollTop();
        // Check if the user is scrolling up and the scroll position is greater than 500px
        if (st < lastScrollTop && st > 500) $("#sticky-masthead").addClass("is-active");
        else $("#sticky-masthead").removeClass("is-active");
        lastScrollTop = st;
    });
    $(window).on("load", function() {});
    var resizeTimer;
    $(window).on("resize", function(e) {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function() {
            if ($(window).width() > 991) {
                $("#mobile-nav-wrapper").removeClass("is-active");
                $("body,html").removeClass("mobile-nav-is-active");
                $(".mobile-nav-toggle").removeClass("is-active");
            }
        }, 50);
    });
});

})();
//# sourceMappingURL=scripts.js.map
